module.exports = "/images/bz.svg?e07bf7d8efb41bd0b9918c98f1a6ec73";